module.exports = __webpack_public_path__ + "img/about_img03.0d36b12d.png";